var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _radialGradient, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _path6, _circle4, _circle5, _circle6, _path7, _circle7, _circle8, _circle9, _path8, _circle10, _circle11, _circle12, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWatercolor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 510 510"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7e8595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555a66"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__f",
    x1: 457.969,
    x2: 476.302,
    y1: 107.061,
    y2: 124.061,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#watercolor_svg__a"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bec3d2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221,
    stopColor: "#c5c9d7",
    stopOpacity: 0.221
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5343,
    stopColor: "#d7dae3",
    stopOpacity: 0.534
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9014,
    stopColor: "#f6f6f8",
    stopOpacity: 0.901
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__g",
    x1: 470.416,
    x2: 449.416,
    y1: 112.454,
    y2: 97.787,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#watercolor_svg__b"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdaaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4213,
    stopColor: "#ffd8a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6519,
    stopColor: "#fed1a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8359,
    stopColor: "#fdc592"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9951,
    stopColor: "#fcb47f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcb37e"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "watercolor_svg__h",
    cx: 197.467,
    cy: 122.057,
    r: 321.442,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#watercolor_svg__c"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__i",
    x1: 306.358,
    x2: -71.584,
    y1: 269.477,
    y2: -86.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdaaa",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__j",
    x1: 347.262,
    x2: 287.083,
    y1: 298.279,
    y2: 238.1,
    gradientTransform: "rotate(28.02 314.662 266.442)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#watercolor_svg__c"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__k",
    x1: 132.659,
    x2: 59.98,
    y1: 190.397,
    y2: 117.718,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#watercolor_svg__c"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__l",
    x1: 259.553,
    x2: 324.44,
    y1: 270.585,
    y2: 335.472,
    gradientTransform: "rotate(16.13 650.507 -402.513)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa425"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__m",
    x1: 284.309,
    x2: 253.397,
    y1: 297.852,
    y2: 254.027,
    gradientTransform: "rotate(16.13 650.507 -402.513)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcee21"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__n",
    x1: 280.039,
    x2: 348.903,
    y1: 308.531,
    y2: 180.453,
    gradientTransform: "rotate(16.13 650.507 -402.513)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b53759"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__o",
    x1: 382.604,
    x2: 309.925,
    y1: 130.276,
    y2: 57.597,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#watercolor_svg__c"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__p",
    x1: 331.976,
    x2: 396.863,
    y1: 79.648,
    y2: 144.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f92814"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__q",
    x1: 356.732,
    x2: 325.82,
    y1: 106.915,
    y2: 63.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa425"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__r",
    x1: 352.461,
    x2: 421.325,
    y1: 117.594,
    y2: -10.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1272d"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__s",
    x1: 248.755,
    x2: 176.076,
    y1: 119.898,
    y2: 47.219,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#watercolor_svg__c"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__t",
    x1: 198.127,
    x2: 263.014,
    y1: 69.27,
    y2: 134.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cffc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a98f7"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__u",
    x1: 222.883,
    x2: 191.972,
    y1: 96.537,
    y2: 52.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cffc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65e1dc"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__v",
    x1: 218.612,
    x2: 287.477,
    y1: 107.216,
    y2: -20.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0469bc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469bc"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__w",
    x1: 127.577,
    x2: 54.898,
    y1: 323.622,
    y2: 250.943,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#watercolor_svg__c"
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__x",
    x1: 76.949,
    x2: 141.836,
    y1: 272.994,
    y2: 337.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92f37f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ab272"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__y",
    x1: 101.705,
    x2: 70.793,
    y1: 300.261,
    y2: 256.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92f37f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffee83"
  }))), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__z",
    x1: 97.434,
    x2: 166.299,
    y1: 310.94,
    y2: 182.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ab272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  }))), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__A",
    x1: 344.016,
    x2: 238.372,
    y1: 436.973,
    y2: 331.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcb37e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  }))), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__B",
    x1: 246.548,
    x2: 291.355,
    y1: 318.44,
    y2: 363.247,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#watercolor_svg__a"
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__C",
    x1: 250.689,
    x2: 204.689,
    y1: 322.662,
    y2: 277.662,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#watercolor_svg__b"
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__D",
    x1: 426.988,
    x2: 532.322,
    y1: -406.942,
    y2: -335.275,
    gradientTransform: "scale(1 -1) rotate(-45 225.033 -13.835)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#watercolor_svg__a"
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#555a66",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555a66"
  }))), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__E",
    x1: 468.021,
    x2: 526.522,
    y1: -387.578,
    y2: -444.078,
    gradientTransform: "scale(1 -1) rotate(-45 225.033 -13.835)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#watercolor_svg__d"
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__F",
    x1: 456,
    x2: 477.001,
    y1: -371.594,
    y2: -310.26,
    gradientTransform: "scale(1 -1) rotate(-45 225.033 -13.835)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#watercolor_svg__d"
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__G",
    x1: 476.401,
    x2: 334.066,
    y1: -379.558,
    y2: -392.558,
    gradientTransform: "scale(1 -1) rotate(-45 225.033 -13.835)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#watercolor_svg__b"
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__e"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f7fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0ddfc"
  }))), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__H",
    x1: 205.755,
    x2: 220.755,
    y1: 356.745,
    y2: 371.745,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#watercolor_svg__e"
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__I",
    x1: 1077.886,
    x2: 1113.887,
    y1: -244.035,
    y2: -365.536,
    gradientTransform: "rotate(-135 787.073 230.466)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ddfc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#c8b7e0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#a595c8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8f81b8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779b3"
  }))), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__J",
    x1: 477.286,
    x2: 483.675,
    y1: -314.489,
    y2: -294.41,
    gradientTransform: "scale(1 -1) rotate(-45 230.808 .109)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#watercolor_svg__e"
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__K",
    x1: 1076.199,
    x2: 1113.199,
    y1: -184.439,
    y2: -256.106,
    gradientTransform: "rotate(-135 787.073 230.466)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#watercolor_svg__d"
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "watercolor_svg__L",
    x1: 477.098,
    x2: 484.356,
    y1: -231.261,
    y2: -208.45,
    gradientTransform: "scale(1 -1) rotate(-45 230.808 .109)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#watercolor_svg__e"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#watercolor_svg__f)",
    d: "M458.77 145.148h-49.31c51.75-44.76 94.27-78.02 99.9-73.48.05.02.08.06.12.09s.06.07.09.12c3.73 4.631-18.07 34.171-50.8 73.27z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#watercolor_svg__g)",
    d: "M450.74 145.148h-30.86c47.75-43.43 85.67-75.77 89.48-73.48.05.02.08.06.12.09s.06.07.09.12c2.02 3.37-23 33.381-58.83 73.27z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#watercolor_svg__h)",
    d: "M428 229.757c12.876 4.032 26.74 3.559 39.463-.915C493.904 219.524 510 194.758 510 168.769c0-9.688-2.242-19.551-7.004-28.849C462.701 61.283 370.086 6.27 262.261 6.27 117.421 6.27 0 105.538 0 227.988s117.421 221.719 262.261 221.719c77.876 0 147.823-28.705 195.852-74.277 22.174-21.043 14.368-58.099-14.368-68.538-4.793-1.748-9.863-2.715-14.944-2.715-2.047 0-4.104.154-6.14.483-12.455 2.026-25.702-2.078-34.906-12.28-13.195-14.635-13.103-37.282.195-51.825 10.543-11.517 26.268-15.117 40.05-10.798zm-142.084 35.709c0-15.972 12.949-28.921 28.921-28.921s28.91 12.948 28.91 28.921c0 15.972-12.938 28.91-28.91 28.91-15.972.001-28.921-12.938-28.921-28.91z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#watercolor_svg__i)",
    d: "M493.843 144.61C453.979 66.816 363.082 16.555 262.261 16.555c-138.937 0-251.976 94.846-251.976 211.434s113.04 211.434 251.976 211.434c72.106 0 140.911-26.041 188.766-71.448 7.796-7.395 11.138-18.091 8.938-28.622-2.201-10.583-9.575-19.109-19.726-22.791-3.836-1.399-7.672-2.098-11.437-2.098-1.522 0-3.034.113-4.494.349a49.045 49.045 0 01-7.858.638c-13.823 0-27.059-5.904-36.336-16.188-16.651-18.461-16.538-47.3.247-65.648 9.256-10.11 22.41-15.91 36.079-15.91 4.978 0 9.904.751 14.635 2.232a50.31 50.31 0 0015.098 2.294c6.047 0 12.054-1.039 17.865-3.096a53.373 53.373 0 0031.862-30.597 53.159 53.159 0 00-2.057-43.928zM314.837 294.377c-15.972 0-28.921-12.938-28.921-28.91s12.949-28.921 28.921-28.921 28.91 12.948 28.91 28.921c0 15.971-12.938 28.91-28.91 28.91z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#watercolor_svg__j)",
    d: "M332.457 232.395c-18.269-9.733-40.968-2.814-50.702 15.455-9.733 18.269-2.805 40.951 15.464 50.684s40.941 2.822 50.674-15.447c9.735-18.268 2.833-40.958-15.436-50.692zm-31.216 58.593c-14.103-7.514-19.439-25.019-11.93-39.113 7.514-14.103 25.019-19.439 39.122-11.925 14.094 7.509 19.43 25.014 11.916 39.117-7.509 14.095-25.014 19.43-39.108 11.921z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100.776,
    cy: 158.514,
    r: 55.194,
    fill: "url(#watercolor_svg__k)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.776,
    cy: 158.514,
    r: 50.1,
    fill: "url(#watercolor_svg__l)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.776,
    cy: 158.514,
    r: 41.812,
    fill: "url(#watercolor_svg__m)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#watercolor_svg__n)",
    d: "M134.746 121.68a49.88 49.88 0 01-1.145 22.997c-7.68 26.582-35.455 41.905-62.037 34.225A49.874 49.874 0 0151.5 167.605c3.346 18.055 16.528 33.596 35.37 39.04 26.582 7.68 54.357-7.643 62.037-34.225 5.444-18.842-.672-38.281-14.161-50.74z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.721,
    cy: 98.393,
    r: 55.194,
    fill: "url(#watercolor_svg__o)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.721,
    cy: 98.393,
    r: 50.1,
    fill: "url(#watercolor_svg__p)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.721,
    cy: 98.393,
    r: 41.812,
    fill: "url(#watercolor_svg__q)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#watercolor_svg__r)",
    d: "M373.132 53.577a49.885 49.885 0 015.284 22.411c0 27.669-22.43 50.1-50.1 50.1a49.888 49.888 0 01-22.411-5.284c8.226 16.417 25.203 27.688 44.816 27.688 27.669 0 50.1-22.43 50.1-50.1 0-19.611-11.272-36.589-27.689-44.815z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 216.872,
    cy: 88.015,
    r: 55.194,
    fill: "url(#watercolor_svg__s)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 216.872,
    cy: 88.015,
    r: 50.1,
    fill: "url(#watercolor_svg__t)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 216.872,
    cy: 88.015,
    r: 41.812,
    fill: "url(#watercolor_svg__u)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#watercolor_svg__v)",
    d: "M239.283 43.199a49.885 49.885 0 015.284 22.411c0 27.669-22.43 50.1-50.1 50.1a49.885 49.885 0 01-22.411-5.284c8.226 16.417 25.203 27.689 44.816 27.689 27.669 0 50.1-22.43 50.1-50.1 0-19.612-11.272-36.59-27.689-44.816z"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.694,
    cy: 291.739,
    r: 55.194,
    fill: "url(#watercolor_svg__w)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.694,
    cy: 291.739,
    r: 50.1,
    fill: "url(#watercolor_svg__x)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.694,
    cy: 291.739,
    r: 41.812,
    fill: "url(#watercolor_svg__y)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#watercolor_svg__z)",
    d: "M118.105 246.923a49.885 49.885 0 015.284 22.411c0 27.669-22.43 50.1-50.1 50.1a49.885 49.885 0 01-22.411-5.284c8.226 16.417 25.203 27.688 44.816 27.688 27.669 0 50.1-22.43 50.1-50.099 0-19.613-11.272-36.59-27.689-44.816z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#watercolor_svg__A)",
    d: "M262.261 449.707c77.876 0 147.823-28.705 195.853-74.276a42.205 42.205 0 003.568-3.845L337.026 246.93a28.811 28.811 0 016.721 18.536c0 15.972-12.938 28.91-28.91 28.91a28.806 28.806 0 01-18.544-6.728L153.965 429.976c33.013 12.671 69.679 19.731 108.296 19.731z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#watercolor_svg__B)",
    d: "M343.75 265.469c0 4.07-.84 7.95-2.36 11.46-4.52 4.84-8.98 9.6-13.38 14.27-19.43 20.62-37.5 39.33-52.39 54.22-77.6 77.6-90.79 73.31-101.71 62.53-.11-.1-.22-.21-.32-.31s-.21-.21-.31-.32c-10.77-10.92-15.06-24.1 62.54-101.7 14.33-14.32 32.19-31.59 51.9-50.18 6.12-5.79 12.42-11.69 18.85-17.68a28.57 28.57 0 018.27-1.21c2.18 0 4.31.24 6.36.71 11.39 2.55 20.23 11.82 22.15 23.44.27 1.55.4 3.14.4 4.77z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#watercolor_svg__C)",
    d: "M343.35 260.698a5748.423 5748.423 0 01-32.13 33.45c-15.93 16.45-30.62 31.43-43.03 43.84-77.17 77.16-87.41 76.58-94.28 69.96-.11-.1-.22-.21-.32-.31s-.21-.21-.31-.32c-6.61-6.86-7.2-17.1 69.97-94.27 12.23-12.23 26.97-26.69 43.15-42.36a6319.96 6319.96 0 0134.8-33.43c11.39 2.551 20.23 11.821 22.15 23.44z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#watercolor_svg__D)",
    d: "M80.61 500.942c-3.412-.841-3.587-5.595-.252-6.703a39.15 39.15 0 0015.377-9.51 39.069 39.069 0 0011.11-22.266c.86-6.125-.067-12.331-2.016-18.202-5.907-17.792-1.465-38.264 13.345-52.01 18.844-17.489 48.424-17.516 67.297-.059 17.137 15.851 20.381 36.259 11.249 56.821-3.311 7.455-8.084 14.17-13.733 20.055-38.396 40.008-82.972 36.659-102.377 31.874z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#watercolor_svg__E)",
    d: "M79.139 500.188c-1.889-1.628-1.539-5.032 1.219-5.949a39.15 39.15 0 0015.377-9.51 39.069 39.069 0 0011.11-22.266c.86-6.125-.067-12.331-2.016-18.202-5.907-17.792-1.465-38.264 13.345-52.01 17.351-16.103 43.797-17.389 62.613-3.866 6.835 11.325 8.282 24.824 4.533 39.251-2.116 8.143-5.845 15.778-10.603 22.717-30.742 44.826-73.746 50.739-95.578 49.835z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#watercolor_svg__F)",
    d: "M80.358 494.239a39.15 39.15 0 0015.377-9.51 39.068 39.068 0 0011.11-22.267c.86-6.125-.067-12.331-2.016-18.201-5.907-17.792-1.465-38.264 13.345-52.01a48.93 48.93 0 013.613-3.043c12.868-9.818 31.63-6.391 39.717 7.629.286.496.537.968.744 1.409 6.293 13.357 5.953 28.288-.515 43.32-3.702 8.603-9.201 16.291-15.722 23.014-22.149 22.835-46.149 32.411-66.885 35.599-1.876-1.632-1.521-5.026 1.232-5.94z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#watercolor_svg__G)",
    d: "M180.15 400.946a53.478 53.478 0 00-1.469-1.413c-15.068-13.938-38.658-13.917-53.704.048-11.352 10.536-15.535 26.836-10.657 41.529 2.621 7.895 3.438 15.546 2.428 22.742-1.497 10.659-6.317 20.324-13.942 27.948a51.537 51.537 0 01-1.937 1.839c19.228.708 48.469-3.951 74.903-31.494 5.156-5.372 9.129-11.156 11.808-17.19 5.132-11.555 8.009-28.57-7.428-44.007l-.002-.002z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#watercolor_svg__H)",
    d: "M269.224 358.568l-46.556-46.556c-33.588 34.436-48.974 55.168-54.468 68.823l32.202 32.202c13.654-5.495 34.386-20.882 68.822-54.469z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#watercolor_svg__I)",
    d: "M255.97 371.23h-82.917c-2.103 3.553-3.7 6.737-4.854 9.605l32.202 32.202c11.804-4.751 28.906-16.904 55.569-41.807z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#watercolor_svg__J)",
    d: "M208.996 406.78l-34.54-34.54a5.407 5.407 0 00-7.647 0l-2.444 2.444a5.407 5.407 0 000 7.647l34.54 34.54a5.407 5.407 0 007.647 0l2.445-2.444a5.408 5.408 0 00-.001-7.647z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#watercolor_svg__K)",
    d: "M227.488 314.022l39.725 39.725c2.718-2.67 5.511-5.436 8.405-8.33 10.795-10.795 22.273-22.612 34.013-34.992h-78.594a1414.285 1414.285 0 00-3.549 3.597z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#watercolor_svg__L)",
    d: "M272.853 352.099l-43.717-43.717a5.407 5.407 0 00-7.647 0l-2.445 2.444a5.407 5.407 0 000 7.647l43.717 43.717a5.407 5.407 0 007.647 0l2.444-2.444a5.406 5.406 0 00.001-7.647z"
  })));
}
export default __webpack_public_path__ + "static/watercolor.8e83463d.svg";
export { SvgWatercolor as ReactComponent };